import dayjs from 'dayjs';
export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const timezoneMap: Record<string, string> = {
  AST: 'America/Puerto_Rico',
  EST: 'America/New_York',
  CST: 'America/Chicago',
  MST: 'America/Denver',
  AZST: 'America/Phoenix',
  PST: 'America/Los_Angeles',
  AKST: 'America/Anchorage',
  HST: 'Pacific/Honolulu',
  SST: 'Pacific/Pago_Pago',
  ChST: 'Pacific/Guam'
};

export const getTimezoneLong = (timezoneShort: string): string => timezoneMap[timezoneShort] ?? timezoneMap['EST'];

export function standardDateFormat(dateString: string) {
  if (!dateString) {
    return '';
  }

  const dateOnly = dateString.split('T')[0];
  const [year, month, day] = dateOnly.split('-').map(Number);
  
  if (year === 1900) {
    return '';
  }
  
  const date = new Date(year, month - 1, day);

  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
  });

  return formatter.format(date);
}

export function longDateFormat(dateString?: string, timeZone?: string,) {
  if (!dateString) {
    return '';
  }

  const dateOnly = dateString.split('T')[0];
  const [year] = dateOnly.split('-').map(Number);

  if (year === 1900) {
    return '';
  }

  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'long',
    timeZone: timeZone ?? 'America/Los_Angeles'
  });

  return formatter.format(new Date(dateString));
}

export function longMonthYearDateFormat(dateString: string) {
  if (!dateString) {
    return '';
  }

  const dateOnly = dateString.split('T')[0];
  const [year, month, day] = dateOnly.split('-').map(Number);
  
  if (year === 1900) {
    return '';
  }
  
  const date = new Date(year, month - 1, day);

  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric'
  });

  return formatter.format(date);
}

export function formatDateToYYYYMMDD(date: string | undefined | null | Date) {
  if (!date) {
    return null;
  }

  const parsedDate = dayjs(date);
  
  if (!parsedDate.isValid()) {
    return null;
  }

  return parsedDate.format('YYYY-MM-DD');
};

export const getCurrentMonthName = (): string => {
  const now = new Date();
  return `${monthNames[now.getMonth()]} ${now.getFullYear()}`;
}

export const getDisplayPeriodName = (refillPeriodName: string): string => {
  try {
    const [monthName, yearStr] = refillPeriodName.split(' ');
    const year = parseInt(yearStr, 10);
    
    const monthIndex = monthNames.indexOf(monthName);

    // If the month name is not valid, return the original period name
    if (monthIndex === -1) {
      return refillPeriodName;
    }
    
    // Create a date for the first day of the period month
    const periodDate = new Date(year, monthIndex, 1);
    
    const now = new Date();
    const currentDate = new Date(now.getFullYear(), now.getMonth(), 1);
    
    if (periodDate < currentDate) {
      return getCurrentMonthName();
    }
    
    return refillPeriodName;
  } catch (error) {
    console.error(error);
    return refillPeriodName;
  }
}
